<template>
    <div>
        <v-row class="pa-4 pb-0" id="loginTradesDesc">
            <v-col
                :cols="cols"
                v-for="item in tileDisplay"
                :key="item.value"
                class="pt-0 pb-0"
                :class="{ 'pb-2': VUETIFY_BREAKPOINT.mobile }"
            >
                <v-card class="mx-auto" max-width="344">
                    <v-card-text>
                        <div>
                            {{ item.text }}
                        </div>
                        <p class="text text--primary mb-0">
                            {{
                                item.value === "server"
                                    ? server
                                    : item.value === "Symbol"
                                    ? symbol
                                    : item.value === "ProfitMode"
                                    ? profitModeOutput
                                    : mergedData[0] === undefined ||
                                      mergedData[0][item.value] === undefined
                                    ? "N/A"
                                    : mergedData[0][item.value]
                            }}
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col :cols="cols" class="pt-0 pb-0">
                <v-card class="mx-auto" max-width="344">
                    <v-card-text>
                        <div>{{ $t("monitor.loginTradesDialog.refresh") }}</div>
                        <v-btn
                            color="primary"
                            icon
                            @click="refresh"
                            x-small
                            id="loginTradesRefresh"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="pa-4 pt-0">
            <v-col cols="12">
                <v-expansion-panels
                    multiple
                    v-model="expansionList"
                    id="loginTradesExpansion"
                >
                    <v-expansion-panel>
                        <v-expansion-panel-header
                            class="pb-0"
                            style="font-weight: 800"
                        >
                            {{ $t("monitor.loginTradesDialog.openTrades") }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            :class="mobileExpansionContentClass"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header class="pa-0">
                                    <div
                                        style="color: #2196f3"
                                        id="loginTradesCalculationReference"
                                    >
                                        {{
                                            $t(
                                                "monitor.loginTradesDialog.calculationReference"
                                            )
                                        }}
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    :class="mobileExpansionContentClass"
                                >
                                    <v-alert
                                        outlined
                                        type="info"
                                        border="left"
                                        dense
                                        prominent
                                    >
                                        <div>
                                            <b>{{
                                                $t(
                                                    "monitor.loginTradesDialog.profitEOD"
                                                )
                                            }}</b>

                                            <ul>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forBuyTrades"
                                                        )
                                                    }}</b>
                                                    <ul>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.buyTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedBeforeToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.buyBeforeTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forSellTrades"
                                                        )
                                                    }}</b>
                                                    <ul>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.sellTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedBeforeToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.sellBeforeTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            <b>{{
                                                $t(
                                                    "monitor.loginTradesDialog.profitMT"
                                                )
                                            }}</b>
                                            <ul>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forBuyTrades"
                                                        )
                                                    }}</b>
                                                    {{
                                                        $t(
                                                            "monitor.loginTradesDialog.buyMTFormula"
                                                        )
                                                    }}
                                                </li>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forSellTrades"
                                                        )
                                                    }}</b>
                                                    {{
                                                        $t(
                                                            "monitor.loginTradesDialog.sellMTFormula"
                                                        )
                                                    }}
                                                </li>
                                            </ul>
                                        </div>
                                    </v-alert>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-card>
                                <v-data-table
                                    :items-per-page="15"
                                    :headers="openTradesHeader"
                                    :header-props="{ sortIcon: null }"
                                    :items="loginOpenTradesData"
                                    :loading="openTradeLoading"
                                    :mobile-breakpoint="0"
                                    :footer-props="{
                                        'items-per-page-text': '',
                                    }"
                                    id="loginTradesDetail"
                                >
                                    <template v-slot:header.profit="{ header }">
                                        {{ header.text }}
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    color="grey"
                                                >
                                                    mdi-information
                                                </v-icon>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "monitor.loginTradesDialog.mtProfitInAccountCurrency"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-slot:header.unrealizedMT="{ header }"
                                    >
                                        {{ header.text }}
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    color="grey"
                                                >
                                                    mdi-information
                                                </v-icon>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "monitor.loginTradesDialog.mtProfitInUSD"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:item.cmd="{ item }">
                                        {{
                                            item["cmd"].toString() === "0"
                                                ? $t("common.word.buy")
                                                : item["cmd"].toString() === "1"
                                                ? $t("common.word.sell")
                                                : item["cmd"].toString()
                                        }}
                                    </template>
                                    <template v-slot:item.volume="{ item }">
                                        {{
                                            item["platform"] === "MT4"
                                                ? (
                                                      item["volume"] / 100
                                                  ).toFixed(lotDigits)
                                                : (
                                                      item["currentVolume"] /
                                                      100
                                                  ).toFixed(lotDigits)
                                        }}
                                    </template>
                                    <template v-slot:item.openTime="{ item }">
                                        {{ toMTTimeString(item["openTime"]) }}
                                    </template>
                                    <template v-slot:item.openPrice="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["openPrice"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.currentAsk="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"][
                                                    "currentAsk"
                                                ]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.currentBid="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"][
                                                    "currentBid"
                                                ]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.eodAsk="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"]["eodAsk"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.eodBid="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"]["eodBid"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ item["profit"].toFixed(2) }}
                                    </template>
                                    <template
                                        v-slot:item.unrealizedMT="{ item }"
                                    >
                                        {{
                                            item["tradeProfitInfo"][
                                                "unrealizedMT"
                                            ].toFixed(2)
                                        }}
                                    </template>
                                    <template
                                        v-slot:item.unrealizedEOD="{ item }"
                                    >
                                        {{
                                            item["tradeProfitInfo"][
                                                "unrealizedEOD"
                                            ].toFixed(2)
                                        }}
                                    </template>
                                    <template
                                        v-slot:item.realizedEOD="{ item }"
                                    >
                                        {{
                                            item["tradeProfitInfo"][
                                                "realizedEOD"
                                            ].toFixed(2)
                                        }}
                                    </template>
                                    <template v-slot:item.tp="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tp"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.sl="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["sl"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.reason="{ item }">
                                        {{
                                            reasonList[
                                                item["reason"].toString()
                                            ]
                                        }}
                                    </template>
                                    <template v-slot:item.commission="{ item }">
                                        {{ item["commission"].toFixed(2) }}
                                    </template>
                                    <template v-slot:item.storage="{ item }">
                                        {{ item["storage"].toFixed(2) }}
                                    </template>
                                    <template v-slot:item.extraInfo="{ item }">
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="pr-2"
                                                >
                                                    mdi-swap-horizontal
                                                </v-icon>
                                            </template>
                                            <div>
                                                <table>
                                                    <tr>
                                                        <td class="pr-2">
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeSymbol"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeSymbol"
                                                                ]
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeAsk"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeAsk"
                                                                ].toFixed(2)
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeBid"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeBid"
                                                                ].toFixed(2)
                                                            }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    id="test"
                                                >
                                                    mdi-calculator-variant
                                                </v-icon>
                                            </template>
                                            <div>
                                                <b>{{
                                                    $t(
                                                        "monitor.loginTradesDialog.profitEOD"
                                                    )
                                                }}</b>
                                                <div>
                                                    {{
                                                        calculationTooltipInWords(
                                                            "open",
                                                            "EOD",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <div>
                                                    {{
                                                        calculationTooltipInNumber(
                                                            "open",
                                                            "EOD",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <b>{{
                                                    $t(
                                                        "monitor.loginTradesDialog.profitMT"
                                                    )
                                                }}</b>
                                                <div>
                                                    {{
                                                        calculationTooltipInWords(
                                                            "open",
                                                            "MT",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <div>
                                                    {{
                                                        calculationTooltipInNumber(
                                                            "open",
                                                            "MT",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                            </div>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-expansion-panel-content> </v-expansion-panel
                    ><v-expansion-panel>
                        <v-expansion-panel-header
                            class="pb-0"
                            style="font-weight: 800"
                        >
                            {{ $t("monitor.loginTradesDialog.closeTrades") }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            :class="mobileExpansionContentClass"
                        >
                            <v-expansion-panel>
                                <v-expansion-panel-header class="pa-0">
                                    <div style="color: #2196f3">
                                        {{
                                            $t(
                                                "monitor.loginTradesDialog.calculationReference"
                                            )
                                        }}
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content
                                    :class="mobileExpansionContentClass"
                                >
                                    <v-alert
                                        outlined
                                        type="info"
                                        border="left"
                                        dense
                                        class="ml-2 mr-2"
                                        prominent
                                    >
                                        <div>
                                            <b>{{
                                                $t(
                                                    "monitor.loginTradesDialog.profitEOD"
                                                )
                                            }}</b>

                                            <ul>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forBuyTrades"
                                                        )
                                                    }}</b>
                                                    <ul>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.closeBuyTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedBeforeToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.closeBuyBeforeTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forSellTrades"
                                                        )
                                                    }}</b>
                                                    <ul>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.closeSellTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                        <li>
                                                            <b>{{
                                                                $t(
                                                                    "monitor.loginTradesDialog.ifTradeOpenedBeforeToday"
                                                                )
                                                            }}</b>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.closeSellBeforeTodayFormula"
                                                                )
                                                            }}
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            <b>{{
                                                $t(
                                                    "monitor.loginTradesDialog.profitMT"
                                                )
                                            }}</b>
                                            <ul>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forBuyTrades"
                                                        )
                                                    }}</b>
                                                    {{
                                                        $t(
                                                            "monitor.loginTradesDialog.closeBuyTodayFormula"
                                                        )
                                                    }}
                                                </li>
                                                <li>
                                                    <b>{{
                                                        $t(
                                                            "monitor.loginTradesDialog.forSellTrades"
                                                        )
                                                    }}</b>
                                                    {{
                                                        $t(
                                                            "monitor.loginTradesDialog.closeSellTodayFormula"
                                                        )
                                                    }}
                                                </li>
                                            </ul>
                                        </div>
                                    </v-alert>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-card>
                                <v-data-table
                                    :items-per-page="15"
                                    :headers="closeTradesHeader"
                                    :header-props="{ sortIcon: null }"
                                    :items="loginCloseTradesData"
                                    :loading="loading"
                                    :mobile-breakpoint="0"
                                    :footer-props="{
                                        'items-per-page-text': '',
                                    }"
                                >
                                    <template v-slot:header.profit="{ header }">
                                        {{ header.text }}
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    color="grey"
                                                >
                                                    mdi-information
                                                </v-icon>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "monitor.loginTradesDialog.mtProfitInAccountCurrency"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-slot:header.unrealizedMT="{ header }"
                                    >
                                        {{ header.text }}
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    small
                                                    color="grey"
                                                >
                                                    mdi-information
                                                </v-icon>
                                            </template>
                                            <span>{{
                                                $t(
                                                    "monitor.loginTradesDialog.mtProfitInUSD"
                                                )
                                            }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:item.cmd="{ item }">
                                        {{
                                            item["cmd"].toString() === "0"
                                                ? $t("common.word.buy")
                                                : item["cmd"].toString() === "1"
                                                ? $t("common.word.sell")
                                                : item["cmd"].toString()
                                        }}
                                    </template>
                                    <template v-slot:item.volume="{ item }">
                                        {{ (item["volume"] / 100).toFixed(2) }}
                                    </template>
                                    <template v-slot:item.openTime="{ item }">
                                        {{ toMTTimeString(item["openTime"]) }}
                                    </template>
                                    <template v-slot:item.closeTime="{ item }">
                                        {{ toMTTimeString(item["closeTime"]) }}
                                    </template>
                                    <template v-slot:item.openPrice="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["openPrice"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.closePrice="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["closePrice"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.eodAsk="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"]["eodAsk"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.eodBid="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tradePriceInfo"]["eodBid"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ item["profit"].toFixed(2) }}
                                    </template>
                                    <template v-slot:item.realizedMT="{ item }">
                                        {{
                                            item["tradeProfitInfo"][
                                                "realizedMT"
                                            ].toFixed(2)
                                        }}
                                    </template>
                                    <template
                                        v-slot:item.realizedEOD="{ item }"
                                    >
                                        {{
                                            item["tradeProfitInfo"][
                                                "realizedEOD"
                                            ].toFixed(2)
                                        }}
                                    </template>
                                    <template v-slot:item.tp="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["tp"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.sl="{ item }">
                                        {{
                                            decimalPlaceCorrection(
                                                symbol,
                                                item["sl"]
                                            )
                                        }}
                                    </template>
                                    <template v-slot:item.reason="{ item }">
                                        {{
                                            reasonList[
                                                item["reason"].toString()
                                            ]
                                        }}
                                    </template>
                                    <template v-slot:item.commission="{ item }">
                                        {{ item["commission"].toFixed(2) }}
                                    </template>
                                    <template v-slot:item.storage="{ item }">
                                        {{ item["storage"].toFixed(2) }}
                                    </template>
                                    <template v-slot:item.extraInfo="{ item }">
                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    class="pr-2"
                                                >
                                                    mdi-swap-horizontal
                                                </v-icon>
                                            </template>
                                            <div>
                                                <table>
                                                    <tr>
                                                        <td class="pr-2">
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeSymbol"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeSymbol"
                                                                ]
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeAsk"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeAsk"
                                                                ].toFixed(2)
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{
                                                                $t(
                                                                    "monitor.loginTradesDialog.exchangeBid"
                                                                )
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                item[
                                                                    "tradePriceInfo"
                                                                ][
                                                                    "exchangeBid"
                                                                ].toFixed(2)
                                                            }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-icon
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    mdi-calculator-variant
                                                </v-icon>
                                            </template>
                                            <div>
                                                <b>{{
                                                    $t(
                                                        "monitor.loginTradesDialog.profitEOD"
                                                    )
                                                }}</b>
                                                <div>
                                                    {{
                                                        calculationTooltipInWords(
                                                            "close",
                                                            "EOD",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <div>
                                                    {{
                                                        calculationTooltipInNumber(
                                                            "close",
                                                            "EOD",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <b>{{
                                                    $t(
                                                        "monitor.loginTradesDialog.profitMT"
                                                    )
                                                }}</b>
                                                <div>
                                                    {{
                                                        calculationTooltipInWords(
                                                            "close",
                                                            "MT",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                                <div>
                                                    {{
                                                        calculationTooltipInNumber(
                                                            "close",
                                                            "MT",
                                                            item
                                                        )
                                                    }}
                                                </div>
                                            </div>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import { helper } from "@components/mixins/helper";

export default {
    mixins: [helper],
    props: {
        loginValue: null,
        server: null,
        symbol: null,
    },
    data() {
        return {
            todayStart: parseInt(this.getMT4Int() / 86400) * 86400,
            tileDisplay: [
                {
                    text: this.$t("common.table.symbol"),
                    value: "Symbol",
                },
                {
                    text: this.$t("common.table.contractSize"),
                    value: "ContractSize",
                },
                {
                    text: this.$t("common.table.profitMode"),
                    value: "ProfitMode",
                },
                {
                    text: this.$t("common.table.typeName"),
                    value: "TypeName",
                },
                {
                    text: this.$t("common.table.server"),
                    value: "server",
                },
            ],
            expansionList: [0],
        };
    },
    computed: {
        ...mapState("LoginSummary", [
            "closeTradesHeader",
            "openTradesHeader",
            "loginCloseTradesData",
            "loginOpenTradesData",
            "reasonList",
            "loading",
            "openTradeLoading",
            "profitMode",
        ]),
        ...mapState("Home", ["lotDigits"]),
        mobileExpansionContentClass() {
            return this.VUETIFY_BREAKPOINT.mobile ? "content-padding" : "";
        },
        cols() {
            return this.VUETIFY_BREAKPOINT.mobile ? 6 : 2;
        },
        mergedData() {
            return [...this.loginOpenTradesData, ...this.loginCloseTradesData];
        },
        profitModeOutput() {
            if (this.mergedData.length) {
                let output = "N/A";
                if (this.server.toString().toUpperCase().includes("MT4")) {
                    output =
                        this.profitMode.MT4[this.mergedData[0].profitMode] ||
                        "N/A";
                } else if (
                    this.server.toString().toUpperCase().includes("MT5")
                ) {
                    output =
                        this.profitMode.MT5[this.mergedData[0].profitMode] ||
                        "N/A";
                } else {
                }
                return output;
            } else {
                return "N/A";
            }
        },
    },
    methods: {
        ...mapActions("LoginSummary", [
            "getLoginCloseTradesAction",
            "getLoginOpenTradesAction",
        ]),
        refresh() {
            const tradesParams = {
                login: this.loginValue,
                symbol: this.symbol,
            };
            this.getLoginCloseTradesAction({
                ...tradesParams,
                liveOrHis: false,
            });
            this.getLoginOpenTradesAction({ ...tradesParams, liveOrHis: true });
        },
        decimalPlaceCorrection(symbol, symbolPrice) {
            const numberParts = symbolPrice.toString().split(".");
            if (numberParts.length == 1) {
                return numberParts[0];
            } else {
                return numberParts[0] + "." + numberParts[1].substring(0, 5);
            }
        },
        calculationTooltipInWords(mode, type, item) {
            if (mode === "open") {
                if (type === "MT") {
                    if (item.cmd === 0) {
                        return this.$t(
                            "monitor.loginTradesDialog.buyMTFormula"
                        );
                    } else if (item.cmd === 1) {
                        return this.$t(
                            "monitor.loginTradesDialog.sellMTFormula"
                        );
                    } else {
                        return this.$t("monitor.loginTradesDialog.unknownType");
                    }
                } else {
                    if (item.cmd === 0) {
                        if (item.openTime > this.todayStart) {
                            return this.$t(
                                "monitor.loginTradesDialog.buyTodayFormula"
                            );
                        } else {
                            return this.$t(
                                "monitor.loginTradesDialog.buyBeforeTodayFormula"
                            );
                        }
                    } else if (item.cmd === 1) {
                        if (item.openTime > this.todayStart) {
                            return this.$t(
                                "monitor.loginTradesDialog.sellTodayFormula"
                            );
                        } else {
                            return this.$t(
                                "monitor.loginTradesDialog.sellBeforeTodayFormula"
                            );
                        }
                    } else {
                        return this.$t("monitor.loginTradesDialog.unknownType");
                    }
                }
            } else if (mode === "close") {
                if (type === "MT") {
                    if (item.cmd === 0) {
                        return this.$t(
                            "monitor.loginTradesDialog.closeBuyTodayFormula"
                        );
                    } else if (item.cmd === 1) {
                        return this.$t(
                            "monitor.loginTradesDialog.closeSellTodayFormula"
                        );
                    } else {
                        return this.$t("monitor.loginTradesDialog.unknownType");
                    }
                } else {
                    if (item.cmd === 0) {
                        if (item.openTime > this.todayStart) {
                            return this.$t(
                                "monitor.loginTradesDialog.closeBuyTodayFormula"
                            );
                        } else {
                            return this.$t(
                                "monitor.loginTradesDialog.closeBuyBeforeTodayFormula"
                            );
                        }
                    } else if (item.cmd === 1) {
                        if (item.openTime > this.todayStart) {
                            return this.$t(
                                "monitor.loginTradesDialog.closeSellTodayFormula"
                            );
                        } else {
                            return this.$t(
                                "monitor.loginTradesDialog.closeSellBeforeTodayFormula"
                            );
                        }
                    } else {
                        return this.$t("monitor.loginTradesDialog.unknownType");
                    }
                }
            } else {
                return null;
            }
        },
        calculationTooltipInNumber(mode, type, item) {
            if (mode === "open") {
                if (type === "MT") {
                    if (item.cmd === 0) {
                        return (
                            "(" +
                            item.tradePriceInfo.currentBid +
                            " - " +
                            item.openPrice +
                            ") * " +
                            (item.volume / 100).toFixed(2) +
                            " * " +
                            item.contractSize +
                            " * " +
                            item.tradePriceInfo.exchangeAsk +
                            " = " +
                            item.tradeProfitInfo.unrealizedMT.toFixed(2)
                        );
                    } else if (item.cmd === 1) {
                        return (
                            "(" +
                            item.openPrice +
                            " - " +
                            item.tradePriceInfo.currentAsk +
                            ") * " +
                            (item.volume / 100).toFixed(2) +
                            " * " +
                            item.contractSize +
                            " * " +
                            item.tradePriceInfo.exchangeAsk +
                            " = " +
                            item.tradeProfitInfo.unrealizedMT.toFixed(2)
                        );
                    } else {
                        return "unknown type";
                    }
                } else {
                    if (item.cmd === 0) {
                        if (item.openTime > this.todayStart) {
                            return (
                                "(" +
                                item.tradePriceInfo.currentBid +
                                " - " +
                                item.openPrice +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        } else {
                            return (
                                "(" +
                                item.tradePriceInfo.currentBid +
                                " - " +
                                item.tradePriceInfo.eodBid +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        }
                    } else if (item.cmd === 1) {
                        if (item.openTime > this.todayStart) {
                            return (
                                "(" +
                                item.openPrice +
                                " - " +
                                item.tradePriceInfo.currentAsk +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        } else {
                            return (
                                "(" +
                                item.tradePriceInfo.eodAsk +
                                " - " +
                                item.tradePriceInfo.currentAsk +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        }
                    } else {
                        return "unknown type";
                    }
                }
            } else if (mode === "close") {
                if (type === "MT") {
                    if (item.cmd === 0) {
                        return (
                            "(" +
                            item.closePrice +
                            " - " +
                            item.openPrice +
                            ") * " +
                            (item.volume / 100).toFixed(2) +
                            " * " +
                            item.contractSize +
                            " * " +
                            item.tradePriceInfo.exchangeAsk +
                            " = " +
                            item.tradeProfitInfo.unrealizedMT.toFixed(2)
                        );
                    } else if (item.cmd === 1) {
                        return (
                            "(" +
                            item.openPrice +
                            " - " +
                            item.closePrice +
                            ") * " +
                            (item.volume / 100).toFixed(2) +
                            " * " +
                            item.contractSize +
                            " * " +
                            item.tradePriceInfo.exchangeAsk +
                            " = " +
                            item.tradeProfitInfo.unrealizedMT.toFixed(2)
                        );
                    } else {
                        return "unknown type";
                    }
                } else {
                    if (item.cmd === 0) {
                        if (item.openTime > this.todayStart) {
                            return (
                                "(" +
                                item.closePrice +
                                " - " +
                                item.openPrice +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        } else {
                            return (
                                "(" +
                                item.closePrice +
                                " - " +
                                item.tradePriceInfo.eodBid +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        }
                    } else if (item.cmd === 1) {
                        if (item.openTime > this.todayStart) {
                            return (
                                "(" +
                                item.openPrice +
                                " - " +
                                item.closePrice +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        } else {
                            return (
                                "(" +
                                item.tradePriceInfo.eodAsk +
                                " - " +
                                item.closePrice +
                                ") * " +
                                (item.volume / 100).toFixed(2) +
                                " * " +
                                item.contractSize +
                                " * " +
                                item.tradePriceInfo.exchangeAsk +
                                " = " +
                                item.tradeProfitInfo.unrealizedEOD.toFixed(2)
                            );
                        }
                    } else {
                        return "unknown type";
                    }
                }
            } else {
                return null;
            }
        },
        toMTTimeString(timestamp) {
            const date = dayjs
                .unix(timestamp)
                .tz("UTC")
                .format("YYYY-MM-DD HH:mm:ss");
            return date;
        },
    },
};
</script>
<style lang="scss" scoped>
b {
    font-weight: 800;
}
.v-tooltip__content.menuable__content__active {
    opacity: 1 !important;
    background-color: gray;
}
.content-padding {
    ::v-deep {
        .v-expansion-panel-content__wrap {
            padding: 0 8px 16px;
        }
    }
}
</style>
